import { instance as axios } from '../http'
import { SUPPLIERS, SUPPLIER_REJECT_REASONS } from '../endpoints'

const getSuppliers = () => axios.get(SUPPLIERS)
const getRejections = () => axios.get(SUPPLIER_REJECT_REASONS)

export default {
  getSuppliers,
  getRejections
}



// WEBPACK FOOTER //
// ./src/repository/api/supplier.js